// extracted by mini-css-extract-plugin
export default {"button":"Button_button__zzBdO","default":"Button_default__+kG9K","primary":"Button_primary__1vY6-","text":"Button_text__0rToD","disabled":"Button_disabled__aMvLY"};